module.exports = __webpack_public_path__ + "img/jiaqi.a93f1de4.png";